/**
 * safeJson(res)
 *
 * res.json() seedha chalane par, jawab HTML hone ki soorat mein
 * "Unexpected token '<'" jaisi be-maani error aati hai. Wo HTML
 * aksar nginx/Cloudflare ka error page hota hai:
 *
 *   413 -> file bahut bari
 *   504 / 524 -> upload ke dauran waqt khatam (dheema net)
 *   502 / 503 -> server abhi jawab nahi de raha
 *
 * Ye helper HTTP code dekh kar SAAF message deta hai.
 * Istemal:
 *   const data = await safeJson(res);   // error par khud throw karta hai
 */
export async function safeJson(res) {
  const text = await res.text();

  // JSON hai? (chahe error ka JSON ho)
  let data = null;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (e) {
    data = null;
  }

  if (data !== null) {
    if (!res.ok) {
      throw new Error(data.error || data.detail || `Request failed (${res.status}).`);
    }
    return data;
  }

  // JSON nahi mila - matlab HTML/error page aaya
  if (res.status === 413) {
    throw new Error('That file is too large. Please choose a smaller photo (under 5 MB) and try again.');
  }
  if (res.status === 504 || res.status === 524 || res.status === 408) {
    throw new Error('The upload took too long and timed out. Please try a smaller photo, or connect to Wi-Fi and try again.');
  }
  if (res.status === 502 || res.status === 503) {
    throw new Error('The server is not responding right now. Please wait a moment and try again.');
  }
  if (res.status === 401 || res.status === 403) {
    throw new Error('Your session has expired. Please log in again.');
  }
  if (res.status >= 500) {
    throw new Error(`Something went wrong on our side (${res.status}). Please try again, or contact support if it keeps happening.`);
  }
  if (res.ok) {
    throw new Error('The server sent an unexpected response. Please refresh the page and try again.');
  }
  throw new Error(`Request failed (${res.status}). Please try again.`);
}

/**
 * Network hi na chale (net band, DNS fail) to fetch khud throw karta hai.
 * Us ko bhi saaf message mein badalne ke liye.
 */
export function networkMessage(err) {
  const m = String((err && err.message) || err || '');
  if (m.includes('Failed to fetch') || m.includes('NetworkError') || m.includes('Load failed')) {
    return 'No internet connection. Please check your network and try again.';
  }
  if (m.includes('Unexpected token') || m.includes('not valid JSON')) {
    return 'The server sent an unexpected response. Please try again.';
  }
  return m || 'Something went wrong. Please try again.';
}
